import React, { Component } from "react";

import ContentLoader from "react-content-loader";
import LazyLoad from "react-lazyload";
import { NavLink } from "react-router-dom";
import Ink from "react-ink";
import axios from "axios";
import DelayLink from "../../../helpers/delayLink";

class RestaurantHorizontalList extends Component {
    state = {
        random_restaurants: [],
    };

    componentDidMount() {


        const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
        axios
            .post('https://pykin.in/public/api/get-random-stores', {
                latitude: userSetAddress.lat,
                longitude: userSetAddress.lng,

            })
            .then((response) => {
                const random_restaurants = response.data.restaurants;

                if (random_restaurants.length) {
                    this.setState({
                        random_restaurants: response.data.restaurants
                    });

                } else {
                    this.setState({
                        random_restaurants: [],
                    });
                }
            });
    }

    render() {
        // const {  } = this.props;


        return (
            <React.Fragment>
                {this.state.random_restaurants.length > 0 && (
                    <div className="mb-5 mt-5" style={{ "fontSize": "large", "paddingLeft": "10px", "fontWeight": "bold" }}>Recommended Restaurants</div>
                )}
                <div className="mr-15 ml-15 mt-10" style={{ display: "grid", gridTemplateColumns: "repeat(3, 2fr)", gridGap: 10 }}>
                    {this.state.random_restaurants.map((restaurant, index) => (
                        <LazyLoad>
                            <DelayLink to={'stores/' + restaurant.slug} key={restaurant.id} style={{ position: 'relative' }}>
                                <div style={{
                                    backgroundImage: `url("${localStorage.getItem('cdn') + restaurant.image}")`,
                                    width: '100%',
                                    height: '8rem',
                                    borderRadius: '0.6rem',
                                    backgroundSize: 'cover',
                                    "boxShadow": "rgb(0 0 0 / 17%) 0px 2px 5px"
                                }}>
                                </div>
                                {restaurant.offer_perc_quick && (
                                    <div
                                        style={{ "fontWeight": "bold", "fontSize": "13px", "backgroundColor": "rgb(253, 193, 6)", "width": "71px", "textAlign": "center", "marginLeft": "11px", "borderRadius": "3px", "left": "-7px", "top": "5px", "position": "absolute", "filter": "drop-shadow(rgba(0, 0, 0, 0.267) 0px 1px 3px)" }}
                                    >
                                        {restaurant.offer_perc_quick}
                                    </div>
                                )}
                                <div>
                                    <p className="mb-0 pl-5 font-size-ml" style={{
                                        maxHeight: '18px',
                                        overflowY: 'hidden',
                                    }}><b>{restaurant.name}</b></p>
                                </div>
                            </DelayLink>
                        </LazyLoad>
                    ))}


                </div>

                <DelayLink to={"/store-type/10"} delay={200}>
                    <div style={{
                        padding: '0px 12px 8px 12px',
                        background: '#fff',
                        marginTop: '15px',
                    }}>
                        <div className="text-center" style={{ "backgroundColor": "#f2a91b", "border": "0.2rem solid rgb(242 170 27)", "borderRadius": "6px", "padding": "5px" }}>
                            <div style={{
                                fontWeight: '700',
                                color: '#fff',
                                fontSize: '18px'
                            }} >View All</div>
                        </div>
                    </div>


                </DelayLink>

            </React.Fragment>
        );
    }
}

export default RestaurantHorizontalList;
